import React from 'react'

export const LoginSignUp = () => {
  return (
<div
  className="div-center"
  style={{ height: "60vh", fontSize: "40px" }}
>
  Login Kommer senere
</div>
  )
}
